var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16041 3.76097L1.00098 9.92032V13L4.08069 13L10.2401 6.84064M7.16041 3.76097L9.36905 1.55234L9.37038 1.55103C9.67442 1.247 9.8267 1.09472 10.0022 1.03768C10.1569 0.987439 10.3235 0.987439 10.4781 1.03768C10.6535 1.09468 10.8056 1.24679 11.1092 1.55039L12.4488 2.88989C12.7537 3.19479 12.9062 3.34731 12.9633 3.5231C13.0135 3.67774 13.0135 3.84431 12.9633 3.99894C12.9062 4.17461 12.7539 4.3269 12.4494 4.63136L12.4488 4.63202L10.2401 6.84064M7.16041 3.76097L10.2401 6.84064",
    stroke: "#586370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconOutline);
export default __webpack_public_path__ + "static/media/edit-icon-outline.1b80e83a0e768f8d874839b1ad6ce9a9.svg";
export { ForwardRef as ReactComponent };